export const defaultShow = [
  {
    name: 'list',
    vPosition: 'bottom',
    hPosition: 'left',
    faClass: 'list'
  },
  {
    name: 'edit',
    vPosition: 'bottom',
    hPosition: 'right',
    faClass: 'edit'
  },
  {
    name: 'delete',
    vPosition: 'bottom',
    hPosition: 'right',
    faClass: 'trash'
  }
]

export let defaultList = [
  {
    name: 'create',
    vPosition: 'head',
    hPosition: 'right',
    faClass: 'plus'
  }
]
